/**
 * Imports only the extensions
 *
 */

import './ui-theme-extensions.scss'
